/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { useTranslation } from 'react-i18next';

import { Skeleton } from '@/components/Skeleton';
import { cn } from '@/lib/cn';
import './loading.css';

/**
 * Placeholder for a route's content area while its chunk or its gate resolves. Every page opens
 * with a title, a row of controls and a grid of cards, so standing in at that shape keeps the
 * frame steady.
 */
export function PageLoading({ cards = 6, className }: { cards?: number; className?: string }) {
  const { t } = useTranslation();
  return (
    <div
      className={cn('ld-page', className)}
      role="status"
      aria-label={t('common.loading')}
      aria-busy="true"
    >
      <div className="ld-page-head">
        <Skeleton width={252} height={24} radius="var(--radius-control)" />
        <Skeleton width={392} height={13} />
      </div>
      <div className="ld-page-chips">
        <Skeleton width={126} height={34} radius="var(--radius-tag)" />
        <Skeleton width={98} height={34} radius="var(--radius-tag)" />
        <Skeleton width={144} height={34} radius="var(--radius-tag)" />
      </div>
      <div className="ld-page-grid">
        {Array.from({ length: cards }).map((_, i) => (
          <div className="ld-page-card" key={i}>
            <div className="ld-page-card-top">
              <Skeleton width={34} height={34} radius="var(--radius)" />
              <Skeleton width={82} height={14} />
            </div>
            <Skeleton width="86%" height={14} />
            <Skeleton width="58%" height={12} />
          </div>
        ))}
      </div>
    </div>
  );
}
